import React from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import Box from '@mui/material/Box';
import AudioOutput from './AudioOutput';
import Statements from './Statements';
import GenerateNote from './GenerateNote';

interface TranscriptionProps {
    isMobile: boolean;
}

const Transcription: React.FC<TranscriptionProps> = ({ isMobile }) => {
    const colors = useAppSelector(state => state.theme.colors);

    return (
        <Box sx={{
            // Common styles
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            borderRadius: 2,
            backgroundColor: colors?.container,
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
            overflow: 'hidden', // Keep overflow hidden, internal components scroll
            boxSizing: 'border-box',
            flexShrink: 0, // Prevent shrinking in mobile flex column
            padding: 2,

            // Conditional Styles based on isMobile
            ...(isMobile ? {
                // --- Mobile Styles ---
                width: '100%',              // Full width
                height: 'auto',             // Height based on content
                position: 'relative',       // Relative positioning for flow layout
                margin: '8px 0',            // Margin top/bottom for spacing
                // Ensure absolute positioning props are unset/auto
                bottom: 'auto',
                left: 'auto',
            } : {
                // --- Desktop Styles ---
                width: '50%',               // Panel width on desktop
                height: '98%',              // Fill full height minus top/bottom margins
                position: 'absolute',       // Absolute positioning
                bottom: '1%',               // Position from bottom
                left: 0,                    // Position from left
                margin: 0,                  // No margin
            })
        }}>
            {/* Internal components determine the height */}
            <AudioOutput isMobile={isMobile} />
            {/* Statements needs to handle its own conditional styling */}
            <Statements isMobile={isMobile} />
            <GenerateNote />
        </Box>
    );
};

export default Transcription;